import React from 'react';
import Sidebar from '../components/Sidebar';
import PageHeader from '../components/PageHeader';
import ClientDirectory from '../components/ClientDirectory';
import './Page.css';
import './Client.css';
import './ClientDetail.css';

const Client: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-layout">
        <Sidebar />
        <main className="page-main">
          <div>
            <PageHeader title="Client" subtitle="Manage client information and relationships" />
          </div>

          <div className="page-content">
            <ClientDirectory />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Client;
